<template>
  <div>
    <div class="md-layout md-gutter" style="justify-content: flex-end">
      <div class="md-layout-item md-size-20">
        <p class="md-title">Filtro</p>
      </div>

      <div class="md-layout-item md-small-size-40 md-size-10">
        <md-field>
          <label for="status">Status</label>
          <md-select id="status" v-model="filterTemp.status" name="status">
            <md-option :value="0"> Aguardando </md-option>
            <md-option :value="1"> Executado </md-option>
            <md-option :value="2"> Cancelado </md-option>
            <md-option :value="3"> Enviado </md-option>
            <md-option :value="4"> Não Enviado </md-option>
            <md-option :value="5"> Expirado </md-option>
          </md-select>
        </md-field>
      </div>

      <div class="md-layout-item md-small-size-40 md-size-10">
        <md-field>
          <label for="origem">Origem</label>
          <md-select id="origem" v-model="filterTemp.origem" name="origem">
            <md-option :value="1"> Mobile </md-option>
            <md-option :value="2"> Web </md-option>
            <md-option :value="3"> Automático </md-option>
            <md-option :value="4"> Notificação </md-option>
            <md-option :value="5"> Calibração </md-option>
          </md-select>
        </md-field>
      </div>

      <div class="md-layout-item md-small-size-50 md-size-20">
        <span class="md-caption">Data inicial</span>
        <VueCtkDateTimePicker
          id="dataInicial"
          v-model="filterTemp.dataInicio"
          :no-label="true"
          label="Selecionar data"
          format="YYYY-MM-DD HH:mm"
        />
      </div>

      <div class="md-layout-item md-small-size-50 md-size-20">
        <span class="md-caption">Data final</span>
        <VueCtkDateTimePicker
          id="dataFim"
          v-model="filterTemp.dataFim"
          :no-label="true"
          label="Selecionar data"
          format="YYYY-MM-DD HH:mm"
        />
      </div>

      <div class="md-layout-item md-small-size-50 md-size-10">
        <md-button
          class="md-raised md-primary mt-4"
          @click="() => handleLimparFiltro()"
        >
          <md-icon>clear</md-icon>
          Limpar
        </md-button>
      </div>

      <div class="md-layout-item md-small-size-50 md-size-10">
        <md-button
          class="md-raised md-primary mt-4"
          @click="() => handleApplyFilters()"
        >
          <md-icon>search</md-icon>
          Buscar
        </md-button>
      </div>
    </div>
    <hr />
    <Loading :loading="!acoes" />

    <div v-if="acoes">
      <div v-if="acoes.length" style="min-height: 60vh">
        <md-table>
          <md-table-row>
            <md-table-head class="md-small-hide"> Usuário </md-table-head>
            <md-table-head>Ação</md-table-head>
            <md-table-head>Origem</md-table-head>
            <md-table-head style="text-align: center"> Status </md-table-head>
            <md-table-head>Ultima Atualização em</md-table-head>
          </md-table-row>
          <md-table-row v-for="acao in acoes" :key="acao.id">
            <md-table-cell class="md-small-hide">
              <p>
                {{ acao.nomeCompleto }}
              </p>
            </md-table-cell>
            <md-table-cell>{{ acao.acaoNome || acao.acao }}</md-table-cell>
            <md-table-cell>{{ getOrigemString(acao.origem) }}</md-table-cell>
            <md-table-cell>
              <show-acao-status :value="acao.status" />
            </md-table-cell>
            <md-table-cell>{{ formatDate(acao.executadoEm) }}</md-table-cell>
            <md-table-cell class="md-small-hide">
              <md-button v-if="isAdmin" class="md-icon-button">
                <md-icon>info</md-icon>
                <md-tooltip md-direction="left">
                  {{ acao.acao }}
                </md-tooltip>
              </md-button>
              <md-button
                class="md-icon-button"
                @click.stop="() => handleOpenHistory(acao.id)"
              >
                <md-icon>history</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
      <div v-else class="align-center mt-5">
        <md-empty-state
          md-rounded
          md-icon="info"
          md-label="Nenhuma ação encontrada"
          md-description="Nenhuma ação foi encontrada com os filtros aplicados"
        />
      </div>
      <flow-pagination
        class="mt-3"
        :current-page="currentPage"
        :page-count="pageCount"
        :page-size="pageSize"
        :total-count="totalCount"
        :total-pages="totalPages"
        @change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'

import FlowPagination from '@/components/FlowPagination.vue'
import ShowAcaoStatus from '@/components/ShowAcaoStatus.vue'
import { EventBus, Topics, Types } from '@/event-bus'
import auth from '@/utils/auth'
import { formatDate, getOrigemString, toUtcIsoString } from '@/utils/transform'

import Loading from '../../components/Loading'
import http from '../../utils/http'

export default {
  name: 'EquipamentoAuditoria',
  components: { FlowPagination, ShowAcaoStatus, Loading },
  mixins: [validationMixin],
  data() {
    return this.getInitialState()
  },
  computed: {
    isAdmin() {
      return auth.isAdmin()
    },
  },
  watch: {
    $route() {
      this.updateStateFromQuery()
      this.searchAcoes(this.currentPage)
    },
  },
  mounted() {
    this.updateStateFromQuery()
    this.searchAcoes(this.currentPage)
  },
  methods: {
    getInitialState() {
      return {
        equipamentoId: null,
        acoes: null,
        filter: {
          status: null,
          origem: null,
          dataInicio: null,
          dataFim: null,
        },
        filterTemp: {
          status: null,
          origem: null,
          dataInicio: null,
          dataFim: null,
        },
        currentPage: 1,
        pageCount: 0,
        totalPages: 1,
        totalCount: 0,
        pageSize: 20,
      }
    },
    handleApplyFilters() {
      if (this.filterTemp.dataInicio || this.filterTemp.dataFim) {
        if (!this.filterTemp.dataInicio) {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Data inicial é obrigatória',
            type: Types.WARNING,
          })
          return
        }

        if (
          this.filterTemp.dataFim &&
          new Date(this.filterTemp.dataInicio) >
            new Date(this.filterTemp.dataFim)
        ) {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Data inicial não pode ser maior que a data final',
            type: Types.WARNING,
          })
          return
        }
      }
      this.filter = { ...this.filterTemp }
      this.updateRoute(1)
    },
    handlePageChange(page) {
      this.updateRoute(page)
    },
    handleLimparFiltro() {
      const initialState = this.getInitialState()
      this.filterTemp = { ...initialState.filterTemp }
    },
    handleOpenHistory(acaoId) {
      this.$emit('open-history', {
        type: 'historico-acao',
        data: {
          acaoId,
        },
      })
    },
    updateStateFromQuery() {
      this.equipamentoId = this.$route.params.equipamentoId
      const initialState = this.getInitialState()
      this.filter.status =
        this.$route.query.status ?? initialState.filter.status
      this.filter.origem =
        this.$route.query.origem ?? initialState.filter.origem
      this.filter.dataInicio = this.$route.query.dataInicio
        ? new Date(this.$route.query.dataInicio)
        : initialState.filter.dataInicio
      this.filter.dataFim = this.$route.query.dataFim
        ? new Date(this.$route.query.dataFim)
        : initialState.filter.dataFim
      this.filterTemp = { ...this.filter }
      this.currentPage =
        parseInt(this.$route.query.page) || initialState.currentPage
      this.pageSize =
        parseInt(this.$route.query.pageSize) || initialState.pageSize
    },
    updateRoute(page) {
      const queryParams = {
        status: this.filter.status,
        origem: this.filter.origem,
        dataInicio: toUtcIsoString(this.filter.dataInicio),
        dataFim: toUtcIsoString(this.filter.dataFim),
        page: page,
        pageSize: this.pageSize,
      }

      const filteredQuery = Object.fromEntries(
        Object.entries(queryParams).filter(([, value]) => value !== null)
      )

      this.$router.push({ query: filteredQuery })
    },
    async searchAcoes(page) {
      this.acoes = null
      const response = (
        await http.get(`equipamento/${this.equipamentoId}/acao`, {
          ...this.getFilter(),
          page: page,
          pageSize: this.pageSize,
        })
      ).paged
      this.currentPage = page
      this.pageCount = response.results.length
      this.totalPages = response.pageCount
      this.totalCount = response.rowCount
      this.acoes = response.results
    },
    getFilter() {
      const filter = {}

      if (this.filter.status !== null) {
        filter.status = this.filter.status
      }

      if (this.filter.origem !== null) {
        filter.origem = this.filter.origem
      }

      if (this.filter.dataInicio !== null) {
        filter.dataInicio = toUtcIsoString(this.filter.dataInicio)
      }

      if (this.filter.dataFim !== null) {
        filter.dataFim = toUtcIsoString(this.filter.dataFim)
      }

      return filter
    },
    formatDate,
    getOrigemString,
    async searchUser(userId, index) {
      const newValue = { ...this.acoes[index] }
      newValue.user = await http.get(`accounts/user/${userId}`)

      this.acoes.splice(index, 1, newValue)
    },
  },
}
</script>

<style lang="scss" scoped>
.left-zero {
  padding-left: 0;
  margin-left: 0;
  margin-right: 5% !important;
}
</style>
